import { render, staticRenderFns } from "./banner-index.vue?vue&type=template&id=1956ec53&scoped=true"
import script from "./banner-index.vue?vue&type=script&lang=js"
export * from "./banner-index.vue?vue&type=script&lang=js"
import style0 from "./banner-index.vue?vue&type=style&index=0&id=1956ec53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956ec53",
  null
  
)

export default component.exports